import React from 'react';
import { To } from 'react-router-dom';
import { Icon } from 'shared/components/ui/icon';
import { QueryParamOptions } from 'shared/lib/react-router-dom';
import { UtmParameters } from 'shared/types/utm-parameters';

import * as Styled from './side-navigation-item.style';

export type SideNavigationItemProps = {
  label: string;
  onClick?: () => void;
  start?: React.ReactNode;
  link?: To;
  activeSearchParamsToIgnore?: (QueryParamOptions | UtmParameters)[];
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  active?: boolean;
  children?: React.ReactNode;
  action?: React.ReactNode;
};

export const SideNavigationItem: React.FC<SideNavigationItemProps> = ({
  label,
  onClick,
  start,
  link,
  activeSearchParamsToIgnore,
  icon,
  active,
  children,
  action,
}) => {
  const Container = link ? Styled.Link : Styled.DisabledLink;

  return (
    <Container
      to={link!}
      $active={!!active}
      onClick={onClick}
      activeSearchParamsToIgnore={activeSearchParamsToIgnore}
    >
      {!!start && (
        <Styled.SubItemIcon $active={!!active}>{start}</Styled.SubItemIcon>
      )}

      {!!icon && (
        <Styled.SubItemIcon $active={!!active}>
          <Icon icon={icon} />
        </Styled.SubItemIcon>
      )}

      <Styled.LinkTitle>{label}</Styled.LinkTitle>

      <Styled.Content>{children}</Styled.Content>

      {!!action && <Styled.Action>{action}</Styled.Action>}
    </Container>
  );
};
